<!-- privacy-policy.component.html -->
<div class="privacy-container">
    <div class="content-wrapper">
        <header class="header">
            <h1>Política de Privacidade</h1>
            <h2>Ariel Plugin</h2>
            <p class="update-date">Última atualização: 12 de novembro de 2025</p>
        </header>

        <div class="intro">
            <p>
                A presente Política de Privacidade tem como objetivo informar, de forma clara e transparente, como o
                <strong>Ariel Plugin</strong>
                coleta, utiliza, armazena e protege os dados pessoais e informações de seus usuários. O Ariel Plugin foi desenvolvido para auxiliar médicos durante consultas online, realizando a
                transcrição de áudio e extração de dados clínicos de forma segura e confidencial.
            </p>
        </div>

        <section class="section">
            <h3>1. Dados Coletados</h3>

            <h4>1.1. Durante o uso do plugin</h4>
            <p>O Ariel Plugin escuta áudios trafegados em conferências online exclusivamente com a finalidade de:</p>
            <ul>
                <li>Transcrever o conteúdo da conversa;</li>
                <li>Extrair informações médicas relevantes para registro da consulta.</li>
            </ul>
            <p>O áudio e o texto transcrito não são utilizados para outros fins, nem são compartilhados com terceiros.</p>

            <h4>1.2. Durante o cadastro do médico</h4>
            <p>Para criar uma conta na plataforma, são coletados os seguintes dados:</p>
            <ul>
                <li>
                    <strong>Nome do médico:</strong>
                    para identificação profissional;
                </li>
                <li>
                    <strong>E-mail:</strong>
                    utilizado como login, comunicação administrativa e recuperação de senha;
                </li>
                <li>
                    <strong>CRM:</strong>
                    número de registro profissional para validação da identidade médica.
                </li>
            </ul>
        </section>

        <section class="section">
            <h3>2. Finalidade do Tratamento de Dados</h3>
            <p>Os dados são tratados com as seguintes finalidades:</p>
            <ul>
                <li>Identificar e autenticar o médico usuário do sistema;</li>
                <li>Transcrever e organizar dados médicos provenientes das consultas;</li>
                <li>Garantir o funcionamento adequado e personalizado do plugin;</li>
                <li>Cumprir obrigações legais e regulatórias aplicáveis à prática médica.</li>
            </ul>
        </section>

        <section class="section">
            <h3>3. Compartilhamento de Dados</h3>
            <div class="highlight">
                <p><strong>O Ariel Plugin não compartilha, vende ou cede dados pessoais ou informações coletadas a nenhuma empresa, pessoa física ou entidade pública ou privada.</strong></p>
            </div>
            <p>Os dados trafegam exclusivamente entre o plugin e os servidores do Ariel por meio de conexões seguras (HTTPS).</p>
        </section>

        <section class="section">
            <h3>4. Armazenamento e Segurança</h3>
            <p>Adotamos medidas técnicas e administrativas para proteger os dados contra acessos não autorizados, perda, alteração ou destruição indevida. Entre as práticas adotadas estão:</p>
            <ul>
                <li>Comunicação criptografada (HTTPS);</li>
                <li>Armazenamento seguro em servidores com controle de acesso restrito;</li>
                <li>Mecanismos de autenticação e auditoria de acesso.</li>
            </ul>
            <div class="highlight">
                <p><strong>Os áudios são deletados em até 24 horas após o término da consulta. Apenas a transcrição é persistida.</strong></p>
            </div>
        </section>

        <section class="section">
            <h3>5. Direitos do Usuário</h3>
            <p>
                Em conformidade com a
                <strong>Lei Geral de Proteção de Dados (LGPD)</strong>
                , o usuário pode a qualquer momento:
            </p>
            <ul>
                <li>Solicitar acesso aos seus dados pessoais;</li>
                <li>Corrigir dados incompletos, inexatos ou desatualizados;</li>
                <li>Solicitar exclusão da conta e dos dados pessoais armazenados;</li>
                <li>Revogar o consentimento para o tratamento de dados.</li>
            </ul>
            <p>Solicitações podem ser feitas através do e-mail de suporte informado abaixo.</p>
        </section>

        <section class="section">
            <h3>6. Alterações nesta Política</h3>
            <p>
                Esta Política de Privacidade poderá ser atualizada a qualquer momento para refletir melhorias no serviço ou alterações legais. A data de atualização será sempre indicada no início do
                documento.
            </p>
        </section>

        <div class="contact-box">
            <h3>7. Contato</h3>
            <p>Em caso de dúvidas, solicitações ou exercício de direitos relacionados à privacidade e proteção de dados, entre em contato com nossa equipe:</p>
            <p class="contact-email">
                <a href="mailto:todos&#64;i9partner.com.br">todos&#64;i9partner.com.br</a>
            </p>
        </div>

        <footer class="footer">
            <p><strong>Ariel Plugin</strong></p>
            <p>Desenvolvido pela equipe i9 Partners</p>
            <p class="footer-logo">
                <a href="mailto:todos&#64;i9partner.com.br">todos&#64;i9partner.com.br</a>
            </p>
        </footer>
    </div>
</div>
